import type { SearchCriteria } from '@/entities/searchCriteria';
import { useTravelataAppConfig } from '@/shared/composables';
import type { PromoPlacement } from '@/shared/di';
import { findA51Placement } from '../lib/promoPlacements';

export function getA51Placement(searchCriteria: SearchCriteria): PromoPlacement | null {
  const { promoPlacements, isMobileDomain } = useTravelataAppConfig();

  return findA51Placement(
    Array.isArray(promoPlacements) ? promoPlacements : [],
    searchCriteria,
    Boolean(isMobileDomain),
  );
}
